export const SENTRY_DSN = import.meta.env.SENTRY_DSN;
